module.exports = global["Comments"] = require("-!/var/www/ridewithgps.com/releases/20261103180724/node_modules/babel-loader/lib/index.js?{\"presets\":[\"es2015\"]}!/var/www/ridewithgps.com/releases/20261103180724/node_modules/eslint-loader/index.js!./comments.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?Comments!./public/javascripts/comments.js-exposed
// module id = 137
// module chunks = 0